import React from 'react';
import { OpenQuizModal } from '../open-quiz-modal/open-quiz-modal';
import { useQuizTriggers } from './utils/use-quiz-triggers';
export var QuizModalsInnerComponent = function QuizModalsInnerComponent(props) {
  var environment = props.environment;
  useQuizTriggers(props);
  return React.createElement(OpenQuizModal, {
    environment: environment
  });
};